import { useMemo } from 'react'
import { SelectOption } from 'types/common'

const useStockAmountOptions = (): SelectOption[] => {
  return useMemo(() => {
    const options: SelectOption[] = []
    for (let i = 0; i < 301; i = (i + 1) | 0) {
      options.push({ label: `${i}個`, value: String(i) })
    }
    return options
  }, [])
}

export default useStockAmountOptions
